APNG.ifNeeded().then(function () {
  var images = document.querySelectorAll(".apng-image");
  for (var i = 0; i < images.length; i++) {
    APNG.animateImage(images[i]);
  }
});

var userAgent = window.navigator.userAgent.toLowerCase();

if (userAgent.indexOf('trident') != -1 || userAgent.indexOf('edge') != -1) {
  $(window).on('load resize', function () {
    var $obj = $('.p-pointmagic-pressedpowderc-keyvisual');
    var width = $obj.width();
    var height = $obj.height();
    $('.apng-image').width(width).height(height);
  });
}

$(function () {

  $('.js-menu').on('click', function() {
    $('.c-header').toggleClass('-is-open');
  });

  $('.js-page-top').on('click', function() {
    $('html,body').animate({scrollTop: 0}, 500);
  });

  $(window).on('scroll', function() {
    const scroll = $(this).scrollTop();
    if (scroll > 500) {
      $('.c-page-top').addClass('-is-show');
    } else {
      $('.c-page-top').removeClass('-is-show');
    }
  });

  $('.js-popup-movie').magnificPopup({
      type: 'iframe',
       iframe: {
       patterns: {
           youtube: {
               index: 'youtube.com',
               id: 'v=',
               src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
            }
       }
    }

  });
//  $(window).load(function(){
//      $('.js-popup-movie').magnificPopup({
//         type: 'iframe',
//             iframe: {
//                 patterns: {
//                     youtube: {
//                         index: 'youtube.com',
//                         id: 'v=',
//                         src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
//                      }
//                 }
//             }
//       });
//  });
  var $setElem = $('.imgChange'),
  pcName = '_pc.', //PC版のファイル名
  spName = '_sp.', //スマホ版のファイル名
  replaceWidth = 812; //切り替える画面サイズ
  $setElem.each(function () {
    var $this = $(this);

    function imgSize() {
      var windowWidth = window.innerWidth;
      if (windowWidth > replaceWidth) {
        //813～
        $this.attr('src', $this.attr('src').replace(spName, pcName)).css({
          visibility: 'visible'
        });
      } else if (windowWidth < replaceWidth) {
        //812～
        $this.attr('src', $this.attr('src').replace(pcName, spName)).css({
          visibility: 'visible'
        });
      }
    }
    $(window).resize(function(){imgSize();});
    imgSize();
  });

  $('.js-anchor-scroll').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  // sp時ヘッダーのsnsを出し分け
  $('.js-toggle-sns-trigger').on('click', function(e) {
    const $target = $(this).find('.js-toggle-sns-target');
    if ($target.hasClass('-show')) {
      $target.removeClass('-show');
    } else {
      $target.addClass('-show');
    }
  });
});
